export default __webpack_public_path__ + "static/media/logoText.74e162ca.png";